import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { api } from "../lib/api";
import ProductCard from "../components/ProductCard";
import Footer from "../components/Footer";

const CATEGORIES = ["Tutti", "Bagno", "Cucina", "Borracce", "Auto & Viaggi", "Casa & Ufficio"];
const SPANS = [
  "md:col-span-4 h-[64vh] min-h-[420px]",
  "md:col-span-2 h-[64vh] min-h-[420px]",
  "md:col-span-2 h-[48vh] min-h-[340px]",
  "md:col-span-4 h-[48vh] min-h-[340px]",
  "md:col-span-3 h-[52vh] min-h-[360px]",
  "md:col-span-3 h-[52vh] min-h-[360px]",
];

export default function Shop() {
  const [products, setProducts] = useState([]);
  const [category, setCategory] = useState("Tutti");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api
      .get("/products", { params: category === "Tutti" ? {} : { category } })
      .then((r) => setProducts(r.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [category]);

  return (
    <main className="pt-20" data-testid="shop-page">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 pt-16 md:pt-24">
        <motion.div
          initial={{ opacity: 0, y: 28 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
        >
          <p className="overline-label mb-6">AB fëlise shop</p>
          <h1 className="font-serif font-light text-5xl md:text-7xl leading-none mb-6">
            La <span className="italic text-primary">Collezione</span>
          </h1>
          <p className="text-muted-foreground tracking-wide max-w-xl mb-14">
            Articoli per la casa testati e selezionati uno a uno: solo quello che useremmo noi.
          </p>
        </motion.div>

        <div className="flex flex-wrap gap-3 mb-14" data-testid="category-filters">
          {CATEGORIES.map((c) => (
            <button
              key={c}
              data-testid={`filter-${c.toLowerCase()}`}
              onClick={() => setCategory(c)}
              className={`h-11 px-6 rounded-full text-xs uppercase tracking-[0.2em] border transition-colors duration-300 ${
                category === c
                  ? "bg-primary text-primary-foreground border-primary"
                  : "border-white/15 text-muted-foreground hover:border-primary/60 hover:text-primary"
              }`}
            >
              {c}
            </button>
          ))}
        </div>

        {loading ? (
          <p className="text-muted-foreground tracking-wide py-24" data-testid="shop-loading">
            Caricamento della collezione…
          </p>
        ) : products.length === 0 ? (
          <p className="text-muted-foreground tracking-wide py-24" data-testid="shop-empty">
            Nessun pezzo in questa categoria al momento.
          </p>
        ) : (
          <div className="grid md:grid-cols-6 gap-5" data-testid="product-grid">
            {products.map((p, i) => (
              <ProductCard key={p.id} product={p} index={i} className={SPANS[i % SPANS.length]} />
            ))}
          </div>
        )}
      </div>
      <Footer />
    </main>
  );
}
